import { VNTABS_SET_MODAL_ACTIVE, VNTABS_SET_TAB_NAME_REQUIRED } from '../VNTabs/ActionTypes'

/**
 * Set State Route
 * This will be read by VNRoutes component and redirect the app
 *
 * @param {String} route
 * @param {?Object} params
 * @returns
 */
export function setIsModalActive(isActive) {
  return (dispatch) => {
    dispatch({
      type: VNTABS_SET_MODAL_ACTIVE,
      isActive,
    })
  }
}

/**
 * Set Tab Name Required
 * This will be read by CartSidebar and CartModal components to display "Tab Name" prompt
 *
 * @param {Boolean} route
 * @param {?Object} params
 * @returns
 */
export function setIsTabNameRequired(isRequired) {
  return (dispatch) => {
    dispatch({
      type: VNTABS_SET_TAB_NAME_REQUIRED,
      isRequired,
    })
  }
}
